import React, { forwardRef, useEffect, useState } from "react";
import LoadingSpinner from "./LoadingSpinner";
import Grid from "./Grid";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "./renderer/StyleRenderer";

const DownloadGridReport = forwardRef(
  ({ tableData, moduleName, action = "DownloadGrid" }, ref) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
      console.log("console.log(tableData):", tableData);
    }, [tableData]);
    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Grid
              heading="Select Download Rows"
              columnVirtualisation={false}
              showDownloadButton={true}
              downloadOnlySelected={true}
              downloadAction={action}
              downloadProps={""}
              multiRowSelection={true}
              autoHeight={false}
              rowHeight={50}
              searchable={true}
              columnDownloadSelect={true}
              content={tableData}
              config={
                moduleName === "cluster"
                  ? [
                      {
                        headerName: "Id",
                        field: "clnId",
                        sort: "desc",
                        hide: true,
                      },
                      {
                        headerCheckboxSelection: true,
                        checkboxSelection: true,
                        headerName: "Code",
                        field: "clnCode",
                      },
                      {
                        headerName: "Name",
                        field: "clnCluster",
                        cellRenderer: ResizableScrollingTextRenderer,
                      },
                      {
                        headerName: "Status",
                        field: "clnStatus",
                        cellRenderer: StatusCellStyle,
                      },
                      {
                        headerName: "Active",
                        field: "clnActive",
                        cellRenderer: ActiveCellStyle,
                      },
                    ]
                  : moduleName === "stakeholder"
                    ? [
                        {
                          headerName: "Id",
                          field: "stkId",
                          sort: "desc",
                          hide: true,
                        },
                        {
                          headerCheckboxSelection: true,
                          checkboxSelection: true,
                          headerName: "Code",
                          field: "stkCode",
                        },
                        {
                          headerName: "Name",
                          field: "stkName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                            {
                                headerName: "Prefix",
                                field: "stkPrefix",
                            },
                        {
                          headerName: "Main Category",
                          field: "stkMainCategoryName",
                        },
                        {
                          headerName: "Min Category",
                          field: "stkMidCategoryName",
                        },
                        {
                          headerName: "Sales Person",
                          field: "stkSalesPersonName",
                        },
                        {
                          headerName: "Parent",
                          field: "stkParentName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Status",
                          field: "stkStatusValue",
                          cellRenderer: StatusCellStyle,
                        },
                        {
                          headerName: "Active",
                          field: "stkActiveValue",
                          cellRenderer: ActiveCellStyle,
                        },
                        {
                          headerName: "Stakeholder Type",
                          field: "stakeholderType",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Agreement Number",
                          field: "agreementCode",
                        },
                        {
                          headerName: "Group",
                          field: "stakeholderGroup",
                        },
                        {
                          headerName: "Telephone No",
                          field: "telephoneNo",
                        },
                        {
                          headerName: "Mobile No",
                          field: "mobileNo",
                        },
                        {
                          headerName: "Email",
                          field: "email",
                        },
                        {
                          headerName: "Address One",
                          field: "addressOne",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Secondary Address",
                          field: "addressTwo",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Country",
                          field: "country",
                        },
                        {
                          headerName: "Export License No",
                          field: "stkExportLicence",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Nominee",
                          field: "stkNominee",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Bank",
                          field: "bankName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Branch",
                          field: "branchName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Bank Account No",
                          field: "bankAccNumber",
                        },
                        {
                          headerName: "Beneficiary Name",
                          field: "accBeneficiary",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Credit Amount",
                          field: "creditAmount",
                        },
                        {
                          headerName: "Remaining Outstanding Amount",
                          field: "remainingOutstanding",
                        },
                        {
                          headerName: "Remaining Credit Amount",
                          field: "remainingCredit",
                        },
                        {
                          headerName: "Tax Reg No",
                          field: "taxNo",
                        },
                        {
                          headerName: "Supplier Birthday",
                          field: "stkBirthDate",
                        },
                        {
                          headerName: "Agreement Status",
                          field: "agreementStatus",
                          cellRenderer: StatusCellStyle,
                        },
                        {
                          headerName: "Agreement Created By",
                          field: "agrCreatedBy",
                        },
                        {
                          headerName: "Agreement Created Date",
                          field: "agrCreatedDate",
                        },
                        {
                          headerName: "Agreement Start Date",
                          field: "agrFromDate",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Agreement To Date",
                          field: "agrToDate",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Agreement Owner Name",
                          field: "agrOwnerName",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Agreement Owner NIC",
                          field: "agrOwnerNic",
                        },
                        {
                          headerName: "Agreement Owner Contact No",
                          field: "agrOwnerContactNo",
                        },
                        {
                          headerName: "Owner NIC",
                          field: "ownerNicStatus",
                        },
                        {
                          headerName: "NIC Front",
                          field: "nicFrontStatus",
                        },
                        {
                          headerName: "NIC Back",
                          field: "nicBackStatus",
                        },
                        {
                          headerName: "Bank Book",
                          field: "bankBook",
                        },
                        {
                          headerName: "Agreement Renew ",
                          field: "agrRenewal",
                        },
                        {
                          headerName: "Addendum",
                          field: "addendum",
                        },
                        {
                          headerName: "Declaration ",
                          field: "declarationStatus",
                        },
                        {
                          headerName: "Created By",
                          field: "createdBy",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                        {
                          headerName: "Created Date",
                          field: "createdDate",
                          cellRenderer: ResizableScrollingTextRenderer,
                        },
                      ]
                    : []
              }
            />
          </>
        )}
      </>
    );
  },
);

export default DownloadGridReport;
